import { render } from "./App.vue?vue&type=template&id=7bc94e1c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=7bc94e1c&lang=css"

import exportComponent from "/Users/lo/project/WebProject/HEIC2JPG/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__